import styled from 'styled-components';

export const FilterIconWrapper = styled.div`
    width: 21px;
    margin: ${({ isDesktop }) => (isDesktop ? '0 4px 0 0' : '0 12px 0 -2px')};
    cursor: pointer;

    svg {
        height: 100%;
        display: flex;
    }
`;
